/* Safely peel 0, 1 or 2 layers of JSON-encoding */
export const safeParse = (val) => {
    if (typeof val !== 'string') return val ?? {};
    try {
      const once = JSON.parse(val);
      return typeof once === 'string' ? JSON.parse(once) : once;
    } catch {
      return {};          // fall back to empty object / array
    }
  };
  
/* ─── Draft lifecycle ───────────────────────────────────────────────────────────
 *
 * generated_scenes.status is enum('queued','rating','complete','error','generating').
 *
 * ⚠️ WHY THESE EXIST RATHER THAN INLINE COMPARISONS.
 * "still working" used to be spelled `status !== 'complete'`, separately, in five
 * places: Editor.js (poll filter, shouldPoll, its dependency array, the modal-sync
 * effect), GenerationModal.js and GeneratedDraftsPanel.js. That is precisely why a
 * failed generation spun forever — 'error' is not 'complete', so all five read a dead
 * job as a live one, and fixing it meant finding every copy.
 *
 * A status is SETTLED when nothing further will change it. Adding a new status now
 * means editing isSettled() once instead of hunting comparisons.
 */
export const isDone    = (s) => s === 'complete';
export const isFailed  = (s) => s === 'error';
export const isSettled = (s) => isDone(s) || isFailed(s);
export const isRunning = (s) => !isSettled(s);   // queued | generating | rating
